import assign from "lodash.assign";
import find from "lodash.find";
import Entitlements from "services/Entitlements";
import { setPrimaryProductDetails, setSelectedProductDetails } from "./subscriptionForm";
import isPaymentValidated from "utils/isPaymentValidated";
import billingAddressFormActions from "./billingAddressForm";
import shippingAddressFormActions from "./shippingAddressForm";
import marketingActions from "./marketing";
import getOfferUrl from "utils/getOfferUrl";
import { ELOQUA_ABANDONED_CART_STATUS } from "common/constants/Constants";

// Actions (must be name-spaced for reducer)
export const COUNTER_OFFERS_SET_SELECTED_OFFER = "COUNTER_OFFERS_SET_SELECTED_OFFER";
export const COUNTER_OFFERS_SET_OFFERS = "COUNTER_OFFERS_SET_OFFERS";

// Reducer
const DEFAULT_STATE = {
    selectedOffer: {},
    offers: []
};

export function counterOffersReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case COUNTER_OFFERS_SET_SELECTED_OFFER:
            return assign({}, state, {
                selectedOffer: action.selectedOffer
            });
        case COUNTER_OFFERS_SET_OFFERS:
            return assign({}, state, {
                offers: action.offers
            });
        default:
            return state;
    }
}

// Action Creators
export function setSelectedOffer(selectedOffer) {
    return {
        type: COUNTER_OFFERS_SET_SELECTED_OFFER,
        selectedOffer
    };
}

export function setOffers(offers) {
    return {
        type: COUNTER_OFFERS_SET_OFFERS,
        offers
    };
}

export function getOffers() {
    return (dispatch, getState) => {
        return getState().counterOffers.offers;
    };
}

export function selectOffer(selectedRatePlanId) {
    return (dispatch, getState) => {
        const {
            counterOffers: {
                offers
            } = {}
        } = getState();

        const offer = find(offers, ({ ratePlanId }) => ratePlanId === selectedRatePlanId);

        dispatch(setSelectedOffer(offer));
        dispatch(setPrimaryProductDetails(offer));
        dispatch(setSelectedProductDetails(offer));
    };
}

export function startAbandonedCart() {
    return (dispatch, getState) => {
        const {
            loginRegister: {
                email
            } = {}
        } = getState();

        dispatch(marketingActions.updateAbandonedCartStatus(email, ELOQUA_ABANDONED_CART_STATUS.SUBSCRIBE_STARTED));
    };
}

export function fetchMatchingCounterOffers(ratePlanIds) {
    return (dispatch, getState) => {
        const {
            subscriptionForm: {
                selectedProductDetails: {
                    productType
                }
            } = {}
        } = getState();

        return Promise.all(ratePlanIds.map((ratePlanId) => Entitlements.getProductRatePlanInformation(ratePlanId)))
            .then((ratePlans) => {
                return ratePlans
                    .map(({ ratePlan }) => ratePlan)
                    .filter((ratePlan) => ratePlan.productType === productType);
            });
    };
}

export function redirectIfNecessary() {
    return (dispatch, getState) => {
        const {
            config: {
                subscriptionOfferUrl
            },
            loginRegister: {
                email
            },
            paymentForm: {
                cardInformation,
                paypalId
            }
        } = getState();

        const isUserValid = Boolean(email);
        const isPaymentValid = isPaymentValidated(cardInformation, paypalId);
        const isBillingAddressValid = dispatch(billingAddressFormActions.validateBillingAddressForSubscription());
        const isShippingAddressValid = dispatch(shippingAddressFormActions.validateShippingAddressForSubscription());

        if (!isUserValid || !isPaymentValid || !isBillingAddressValid || !isShippingAddressValid) {
            window.location.replace(getOfferUrl(subscriptionOfferUrl));
        }
    };
}

export default {
    setOffers,
    setSelectedOffer,
    selectOffer,
    fetchMatchingCounterOffers,
    redirectIfNecessary,
    startAbandonedCart
};
